export let VIDEO_CARDS_POSITIONS; // TOP_LEFT = 3,
// TOP_RIGHT = 4,
(function (VIDEO_CARDS_POSITIONS) {
  VIDEO_CARDS_POSITIONS[VIDEO_CARDS_POSITIONS["BOTTOM_LEFT"] = 1] = "BOTTOM_LEFT";
  VIDEO_CARDS_POSITIONS[VIDEO_CARDS_POSITIONS["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
})(VIDEO_CARDS_POSITIONS || (VIDEO_CARDS_POSITIONS = {}));
//# sourceMappingURL=positions.js.map